import React from 'react'

import { Fieldset, Input } from '@fourthwall/components'

import { useTierContext } from '../../hooks/useTierContext'
import { FormFields } from '../../providers/TierProvider/types'

export const Title = () => {
  const { form, isLoading } = useTierContext()

  return (
    <Fieldset.Row>
      <Fieldset.Item>
        <Input label="Tier title" disabled={isLoading} {...form.getFieldProps(FormFields.title)} />
      </Fieldset.Item>
    </Fieldset.Row>
  )
}
